// ---------------------------------------------------------------------------
// Simple password-based auth using sessionStorage
// Password is read from TOOL_PASSWORD environment variable (server-side only).
// ---------------------------------------------------------------------------

const SESSION_KEY = 'codeallocator_auth';

export async function checkPassword(input: string): Promise<boolean> {
  try {
    const res = await fetch('/api/auth/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password: input }),
    });
    if (!res.ok) return false;
    const data = await res.json();
    return data.valid === true;
  } catch {
    return false;
  }
}

export function setAuthSession(): void {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(SESSION_KEY, 'true');
  }
}

export function clearAuthSession(): void {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(SESSION_KEY);
  }
}

export function isAuthenticated(): boolean {
  if (typeof window !== 'undefined') {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  }
  return false;
}